import {render} from 'react-dom';
import {generateRandomString} from './string-generator';

type Resolver = () => void;
type Factory = ((resolve: Resolver) => JSX.Element);

export function renderReactComponent(factory: Factory): Promise<void> {
	const parentID = generateRandomString();
	const holder = document.createElement('div');
	holder.id = parentID;
	document.body.appendChild(holder);
	return new Promise<void>((resolve, reject) => {
		try {
			const element = factory(resolve);
			render(element, holder);
		} catch (e) {
			reject(e);
		}
	}).finally(() => {
		document.body.removeChild(holder);
	});
}
